var EditBasicUserForm = React.createClass({
  propTypes: {
    user: React.PropTypes.object.isRequired,
    onSaveDone: React.PropTypes.func.isRequired,
    onCancel: React.PropTypes.func.isRequired
  },
  getInitialState() {
    let user = this.props.user;

    return {
      fname: user.firstName,
      lname: user.lastName,
      username: user.username,
      email: user.emailAddress,
      errorMessage: ""
    }
  },
  saveClicked(e) {
    e.preventDefault();

    if (!this.validateForm()) return;

    let data = {
      fname: this.state.fname,
      lname: this.state.lname,
      email: this.state.email,
      SToken: Config.csrf.value
    };

    let url = `${Config.contextPath}/controller/save/userprofile/`;
    $.post(url, data)
      .done(r => {
        if (r.success) {
          this.props.onSaveDone(r.user);
        } else {
          this.showError(r.message);
        }
      });
  },
  inputChanged(e) {
    let key = e.target.getAttribute("name");
    let o = {};
    o[key] = e.target.value;
    this.setState(o);
  },
  validateForm() {
    let {
      fname,
      lname,
      email,
      username
    } = this.state;

    this.clearError();

    if (RA.Utils.isBlank(fname)) {
      this.showError(Labels.getLabel("First name cannot be blank"));
      return false;
    }

    if (RA.Utils.isBlank(lname)) {
      this.showError(Labels.getLabel("Last name cannot be blank"));
      return false;
    }

    if (RA.Utils.isBlank(email)) {
      this.showError(Labels.getLabel("Email address cannot be blank"));
      return false;
    }

    var emailPattern = /^([a-zA-Z0-9_\.\-'!#\$%\&\*\+\/=\?\^`\{\}\|~])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,})+$/;
    if (!emailPattern.test(email)) {
      this.showError(Labels.getLabel("Email address does not appear to be valid"));
      return false;
    }

    return true;
  },
  clearError() {
    this.setState({errorMessage: ""});
  },
  showError(message) {
    this.setState({errorMessage: message});
    window.scrollTo(0, this.refs.form.offsetTop);
    $(this.refs.errorWrap).hide().fadeIn("fast");
  },
  renderError() {
    if (RA.Utils.isNotBlank(this.state.errorMessage)) {
      return  (
        <div ref="errorWrap">
          <AlertMessage alertType="danger">
            <strong>{Labels.getLabel("Error")}:</strong>
            {" " + this.state.errorMessage}
          </AlertMessage>
        </div>
      )
    }
  },
  render() {
    let {user} = this.props;

    return (
      <form onSubmit={this.saveClicked} ref="form">
        <h2 className="form__title">{Labels.getLabel("Edit Basic Info")}</h2>
        {this.renderError()}

        <div className="form-group has-float-label">
          <input type="text"
            id="profileFname"
            className="form-control"
            name="fname"
            maxLength="50"
            required={true}
            onChange={this.inputChanged}
            value={this.state.fname}
			placeholder="&nbsp;"/>
          <label htmlFor="profileFname">{Labels.getLabel("First Name")}</label>
        </div>

        <div className="form-group has-float-label">
          <input type="text"
            id="profileLname"
            className="form-control"
            name="lname"
            maxLength="50"
            required={true}
            onChange={this.inputChanged}
            value={this.state.lname}
			placeholder="&nbsp;"/>
          <label htmlFor="profileLname">{Labels.getLabel("Last Name")}</label>
        </div>

        <div className="form-group has-float-label">
          <input type="email"
            id="profileEmailAddress"
            className="form-control"
            name="email"
            maxLength="50"
            required={true}
            onChange={this.inputChanged}
            value={this.state.email}
			placeholder="&nbsp;"/>
          <label htmlFor="profileEmailAddress">{Labels.getLabel("Email Address")}</label>
        </div>

        <div className="text-right">
          <button type="submit" className="btn btn-primary" onClick={this.saveClicked}>{Labels.getLabel("Save")}</button>
          {" "}
          <button type="button" className="btn btn-default" onClick={this.props.onCancel}>{Labels.getLabel("Cancel")}</button>
        </div>
      </form>
    );
  }
});